/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ContentsWalletListData model module.
 * @module model/ContentsWalletListData
 * @version 1.0
 */
class ContentsWalletListData {
    /**
     * Constructs a new <code>ContentsWalletListData</code>.
     * @alias module:model/ContentsWalletListData
     */
    constructor() { 
        
        ContentsWalletListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ContentsWalletListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ContentsWalletListData} obj Optional instance to populate.
     * @return {module:model/ContentsWalletListData} The populated <code>ContentsWalletListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ContentsWalletListData();

            if (data.hasOwnProperty('walletNo')) {
                obj['walletNo'] = ApiClient.convertToType(data['walletNo'], 'Number');
            }
            if (data.hasOwnProperty('walletDesc')) {
                obj['walletDesc'] = ApiClient.convertToType(data['walletDesc'], 'String');
            }
            if (data.hasOwnProperty('balancePer')) {
                obj['balancePer'] = ApiClient.convertToType(data['balancePer'], 'Number');
            }
            if (data.hasOwnProperty('balanceXper')) {
                obj['balanceXper'] = ApiClient.convertToType(data['balanceXper'], 'Number');
            }
            if (data.hasOwnProperty('balanceArb')) {
                obj['balanceArb'] = ApiClient.convertToType(data['balanceArb'], 'Number');
            }
            if (data.hasOwnProperty('balanceUsdt')) {
                obj['balanceUsdt'] = ApiClient.convertToType(data['balanceUsdt'], 'Number');
            }
            if (data.hasOwnProperty('balanceHvh')) {
                obj['balanceHvh'] = ApiClient.convertToType(data['balanceHvh'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ContentsWalletListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ContentsWalletListData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['walletDesc'] && !(typeof data['walletDesc'] === 'string' || data['walletDesc'] instanceof String)) {
            throw new Error("Expected the field `walletDesc` to be a primitive type in the JSON string but got " + data['walletDesc']);
        }

        return true;
    }


}



/**
 * @member {Number} walletNo
 */
ContentsWalletListData.prototype['walletNo'] = undefined;

/**
 * @member {String} walletDesc
 */
ContentsWalletListData.prototype['walletDesc'] = undefined;

/**
 * @member {Number} balancePer
 */
ContentsWalletListData.prototype['balancePer'] = undefined;

/**
 * @member {Number} balanceXper
 */
ContentsWalletListData.prototype['balanceXper'] = undefined;

/**
 * @member {Number} balanceArb
 */
ContentsWalletListData.prototype['balanceArb'] = undefined;

/**
 * @member {Number} balanceUsdt
 */
ContentsWalletListData.prototype['balanceUsdt'] = undefined;

/**
 * @member {Number} balanceHvh
 */
ContentsWalletListData.prototype['balanceHvh'] = undefined;






export default ContentsWalletListData;

